import classNames from "classnames";
import React, { FunctionComponent, useCallback } from "react";
import { MenuProps } from "react-select/src/components/Menu";

import { PositionWrapper } from "../../../../../PositionWrapper";
import { SELECT_CLASS_NAME } from "../types";

const baseClass = `${SELECT_CLASS_NAME}__auto-positioned-menu`;
const popperTargetClass = `${baseClass}-popper-target`;

const SIZE_MAP: { [index: string]: number } = {
  sm: 24,
  md: 32,
  lg: 38,
};

export const AutoPositionedMenu: FunctionComponent<MenuProps<any>> = ({
  className,
  children,
  selectProps: { size, inputValue },
  innerProps,
  options,
}) => {
  const classes = classNames(className, baseClass, {
    [`${baseClass}--size-${size}`]: size,
  });
  const targetClasses = classNames(popperTargetClass, {
    [`${popperTargetClass}--size-${size}`]: size,
  });

  // This is not a perfect solution but I've tried
  // few approaches and this seems to be the best
  const calculateOffset = useCallback(
    (dataOptions: any) => {
      if (dataOptions.placement === "top-start") {
        return {
          ...dataOptions,
          offsets: {
            ...dataOptions.offsets,
            popper: {
              ...dataOptions.offsets.popper,
              top: dataOptions.offsets.popper.top - SIZE_MAP[size],
            },
          },
        };
      }
      return dataOptions;
    },
    [size],
  );

  const PopperComponent = (
    <div {...innerProps} className={classes}>
      {children}
    </div>
  );

  return (
    <PositionWrapper
      className={`${baseClass}-wrapper`}
      key={`${options.length}-${inputValue}`}
      modifiers={{
        offset: {
          fn: calculateOffset,
        },
      }}
      popperComponent={PopperComponent}
      targetClassName={targetClasses}
    />
  );
};
